import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APP_VERSION } from 'src/app/version';

/**
 * Auth Interceptor
 *
 * Automatically adds Bearer token authentication headers to all API requests.
 * Reads tokens from localStorage (tidy_token and tidy_token_type).
 * Also adds X-App-Version header for internal API calls.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenType = localStorage.getItem('tidy_token_type');
    const token = localStorage.getItem('tidy_token');

    // Only add headers if we have auth tokens
    if (tokenType && token) {
      const headers: { [key: string]: string } = {
        'Authorization': `${tokenType} ${token}`,
        'Content-Type': 'application/json'
      };

      // Add app version header for internal API calls
      if (!this.isExternalUrl(req.url)) {
        headers['X-App-Version'] = APP_VERSION;
      }

      const cloneReqParams = this.isExternalUrl(req.url) ? {} : { setHeaders: headers };
      const clonedReq = req.clone(cloneReqParams);

      return next.handle(clonedReq);
    }

    return next.handle(req);
  }

  private isExternalUrl(url: string): boolean {
    if (url.startsWith(environment.api_url)) {
      return false;
    }
    if (environment.pmsites_url && url.startsWith(environment.pmsites_url)) {
      return false;
    }
    return url.indexOf('https://') === 0 || url.indexOf('http://') === 0;
  }
}
